import { AllessehQuerySortKeyTypes, AllessehQuerySortOrderType } from 'hooks/useAllessehContentQuery';

export const DEFAULT_PRODUCT_VALUE = ['WSJ Japanese'];

export const SECTION_TYPES = {
  ASIA_AND_OCEANIA: 'J-Asia Oceania',
  AUTOS: 'J-Autos',
  BUSINESS: 'J-Business',
  CAPITAL_ACCOUNT: 'J-Capital Account',
  CAREERS: 'J-Careers',
  CHINA: 'J-China',
  CHINA_NEWSLETTER: 'J-China Newsletter',
  EARNINGS: 'J-Earnings',
  EDITOR_COLUMN: 'J-Editor Column',
  ELECTION_2024: 'J-Election 2024',
  ENERGY: 'J-Energy',
  EUROPE_AND_RUSSIA: 'J-Europe & Russia',
  HEALTHCARE: 'J-Healthcare',
  HEARD: 'J-Heard',
  HENSHUCHO: 'J-Henshucho',
  JAPAN: 'J-Japan',
  JOURNAL_REPORTS: 'J-Journal Reports',
  KEYWORDS: 'J-Keywords',
  KIKO: 'J-Kiko',
  LIFESTYLE: 'J-Lifestyle',
  MARKETS: 'J-MARKETS',
  MIDDLE_EAST_AND_AFRICA: 'J-Middle East & Africa',
  MONETARY_POLICY: 'J-Monetary Policy',
  OLYMPICS: 'J-Olympics',
  OPINION: 'J-Opinion',
  PERSONAL_TECHNOLOGY: 'J-Personal Technology',
  SHASETSU: 'J-Shasetsu',
  STREET_WISE: 'J-StreetWise',
  TECH: 'J-Tech',
  THE_INTELLIGENT_INVESTOR: 'J-The Intelligent Investor',
  THE_OUTLOOK: 'J-The Outlook',
  USA: 'J-Usa',
  WORLD: 'J-World',
  WORLD_ECONOMY: 'J-World Economy',
  WORLD_CUP: 'J-World Cup'
};

export const DEFAULT_SORT = {
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }]
};

export const createSupportingModule = (value: string[]) => ({
  query: {
    and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }, { terms: { key: 'SectionType', value } }]
  },
  ...DEFAULT_SORT
});
